AuthRoute = require 'mixins/authenticated-route'

App.BonusCategoriesBonusCategoryEditRoute = Em.Route.extend AuthRoute,
  controllerName: 'bonus-categories.edit'
  templateName:   'bonus-categories.edit'